module.exports = __webpack_public_path__ + "static/img/designBanner1.a5a1695.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designBanner1.gif
// module id = w83U
// module chunks = 2